.wrapper {
  position: relative;
  width: 100%;
}

.inner {
  display: flex;
  flex-direction: row;
}

.timeline {
  position: relative;
  width: 100%;
  height: 3px;
  margin: auto 0;
  background: var(--timeline);
}

.timestamp {
  width: 55px;
  font-weight: var(--font-weight-light);
  color: var(--on-background);
}

.end {
  text-align: right;
}

.markerWrapper {
  position: relative;
}

.markers {
  display: flex;
}

.marker {
  position: absolute;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 2rem;
  cursor: pointer;
  transform: translateX(-50%);
}

.inactive .markerInner {
  display: inline-block;
  color: var(--timeline-inactive);
  background-color: currentColor;
  border: 2px solid var(--episode-card-background);
  border-radius: 50%;
  transform: scale(0.5);
  transition:
    blackground-color 150ms,
    transform 150ms;

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: "";
    border-radius: 100%;
    box-shadow: 0 0 0 1px currentColor;
    transition: transform 250ms;
  }
}

.inactive:hover .markerInner {
  color: var(--timeline-active);
  cursor: pointer;
  transform: scale(1);

  &::after {
    transform: scale(1.15);
  }
}

.inactive:active .markerInner {
  transform: scale(0.5);

  &::after {
    transform: scale(1);
  }
}

.markerInner {
  position: relative;
  width: 1.25rem;
  height: 1.25rem;
  color: var(--timeline-active);
  border: 2px solid transparent;
  transition: color 0.25s;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 70%;
    height: 70%;
    transform: translate(-50%, -50%);
  }

  &.positive {
    color: var(--sentiment-positive);
  }

  &.negative {
    color: var(--sentiment-negative);
  }

  &.neutral {
    color: var(--gray-500);
  }
}

.active {
  z-index: 2;
  display: inline-flex;
}

.cluster {
  position: absolute;
  min-width: 1rem;
  height: 3px;
  background: var(--timeline-cluster-color);
  border-radius: 3px;
}

.hidden {
  opacity: 0.5;
  filter: grayscale(100%);
}
